import {
  IonList,
  IonListHeader,
} from '@ionic/react';
import React, { useRef, useEffect } from 'react';
import { Inspection } from '../models/Inspection';
import InspectionListItem from './InspectionListItem';

interface OwnProps {
  inspections: Inspection[];
}

interface StateProps {
}

interface InspectionListProps extends OwnProps, StateProps {}

const InspectionList: React.FC<InspectionListProps> = ({
  inspections,
}) => {
  const inspectionListRef = useRef<HTMLIonListElement>(null);

  useEffect(() => {
    if (inspectionListRef.current) {
      inspectionListRef.current.closeSlidingItems();
    }
  }, []);

  if (inspections.length === 0) {
    return (
      <IonList>
        <IonListHeader>データがありません。</IonListHeader>
      </IonList>
    );
  }

  return (
    <>
      <IonList ref={inspectionListRef}>
        {inspections.map((record, index: number) => (
          <InspectionListItem
            key={`record-${index}`}
            inspection={record}
          />
        ))}
      </IonList>
    </>
  );
};

export default InspectionList;
